export default __webpack_public_path__ + "static/media/logo.d31d1810.png";